import BaseToast from './Toast';

// EXPORT
export const Toast = BaseToast;
export type { ToastProps } from './Toast.interface';
